const wrapper = "_35sw32m2xm";
const container = "_35scrn6l73";
const label = "_35sl1pykln";
const linebreak = "_35sl6x3qya";

export { container, label, linebreak, wrapper };
import "./molecule.dropzones.style.linaria.module.css";
//# sourceMappingURL=molecule.dropzones.style.js.map
